import componentState from '@/mixins/component-state'
import scrollLock from '@/mixins/scroll-lock'
import Vue from 'vue'
import socket from '@/libs/socket'
import smoothscroll from 'smoothscroll-polyfill'

import Toolbar from '@/components/Base/NavToolbar'
import NavFooter from '@/components/Base/NavFooter'

export default {
  name: 'app',
  components: {
    Toolbar,
    NavFooter
  },
  mixins: [componentState, scrollLock],
  data: function () {
    return {
      seenOpenInApp: false
    }
  },
  created: function () {
    smoothscroll.polyfill()

    // Make sure to wait until the router gets loaded
    this.$router.onReady(() => {
      this.$store.dispatch('initializeUtmFromLocalStorage')
      const utmParams = {
        utmSource: this.$route.query.utm_source || '',
        utmMedium: this.$route.query.utm_medium || '',
        utmCampaign: this.$route.query.utm_campaign || '',
        utmTerm: this.$route.query.utm_term || '',
        utmContent: this.$route.query.utm_content || ''
      }
      if (Object.keys(utmParams).some(k => utmParams[k])) {
        this.$store.dispatch('setUtmParams', {
          ...utmParams,
          query: window.location.search || '',
          userAgent: navigator.userAgent,
          referrer: document.referrer
        })
      }
    })
  },
  mounted: function () {
  },
  computed: {
    inLocalIframe: function () {
      try {
        if (this.$route.query.iframe) {
          return false
        }

        return top.location !== self.location && top.location.origin === Vue.prototype.$webRoot
      } catch (error) {
        return false
      }
    },
    maintenanceMode: function () {
      return this.$store.getters.getFromSession('maintenanceMode')
    }
  },
  methods: {
    initCallbacks: function () {
      this._register('openChooseTemplateModal', this.openChooseTemplateModal)
      this._register('checkUserLanguage', this.checkUserLanguage)
      this._register('lockScrolling', this.lockScrolling)
      this._register('unlockScrolling', this.unlockScrolling)
      window.addEventListener('beforeunload', this.leaving)
    },
    openChooseTemplateModal: function () {
      this.$refs.toolbar.openChooseTemplateModal()
    },
    leaving: function () {
      socket.log(this.$route.fullPath, 'unload')
    }
  }
}
